import React from "react";
import PropTypes from "prop-types";
import { Button } from "@material-ui/core";

import useStyles from "./useStyles";

const LinkStyledButton = (props) => {
  const { children, handleClick } = props;
  const classes = useStyles();

  return (
    <Button color="primary" className={classes.action} onClick={handleClick}>
      {children}
    </Button>
  );
};

LinkStyledButton.propTypes = {
  children: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default LinkStyledButton;
